export default __webpack_public_path__ + "static/10-82c14c63d073fa9eac6b846660683b8f.jpg";